import { crdm_service } from "../../api/restclient";

export const get_clusters_list = () => {
  return crdm_service.get("/clusters/primaryinfo").then((resp) => {
    return Promise.resolve(resp);
  });
};

export const get_area_list = () => {
  return crdm_service.get("/peppareas/primaryinfo");
};

export const get_branch_by_code = (code) => {
  return crdm_service.get(`/peppbranches/primaryinfo/${code}`);
};

export const get_crdm_pepp_hierarchy = (data) => {
  const arrayParams = new URLSearchParams();
  arrayParams.append("isSpecial", "true");
  data.cluster_ids.forEach((cluster_id) => {
    arrayParams.append("clusterids", cluster_id.toString());
  });
  return crdm_service.get(`/peppbranches/clusters?${arrayParams.toString()}`);
};
